<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title">Baseline History</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="24">
          <a-col :span="8">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @change="onSearch">
                <a-icon slot="suffix" class="custom-suffix" type="loading" spin v-show="isSearching" />
              </a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :clientPaging="false"
            :pagination="pagin"
            :columns="BaselineHistoryColumn"
            :dataSource="filterData"
            :tableSize="tableSize">
            <template slot="webpageUrl" slot-scope="{ record }">
              <div>
                <a-tooltip :title="record.webpageUrl" placement="topLeft">
                  <router-link :to="'/webpages/' + record.webpageId" class="webpab-ext-link">
                    {{ record.webpageUrl }}
                  </router-link>
                </a-tooltip>
              </div>
            </template>
            <template slot="baselineAt" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  <time>
                    {{ record.baselineAt | dateString }}
                  </time>
                  <br />
                  <time>
                    {{ record.baselineAt | timeString }}
                  </time>
                </p>
              </div>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { indexItemTable } from '@shared/helpers/utils';
  import { BaselineHistoryColumn } from '../columnsTable/BaselineHistoryColumn';
  import PollingHistoryService from '../services/PollingHistory.service';

  export default {
    name: 'BaselineHistory',
    data() {
      var pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        BaselineHistoryColumn,
        filterData: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isSearching: false,
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    beforeMount() {},
    mounted() {
      this.fetchList();
    },
    beforeDestroy() {},
    methods: {
      onSearch: debounce(function (inputChangeEvent) {
        const inputSearchValue = inputChangeEvent.target.value;
        this.filterParams.search = inputSearchValue ? String(inputSearchValue).trim().toLowerCase() : '';
        this.fetchList();
      }, 800),
      async fetchList() {
        try {
          this.isSearching = true;
          const responseData = await PollingHistoryService.fetchListBaselineHistory(this.pagin.current, this.pagin.pageSize, this.filterParams.search);
          const { data, total } = responseData;
          this.filterData = (data || []).map((item, index) => ({
            index: indexItemTable(this.pagin.current, this.pagin.pageSize, index),
            id: item.id,
            webpageName: (item.url && item.url.name) || '',
            webpageUrl: (item.url && item.url.url) || '',
            webpageId: (item.url && item.url.id) || '',
            baselineAt: item.start_time,
          }));
          this.pagin.total = total;
          this.isSearching = false;
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
        this.fetchList();
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
    white-space: nowrap;
  }
  .nav-link-detail {
    width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-link-detail {
    display: inline-block;
  }
  .custom-suffix {
    font-size: 20px;
    color: #20a4b8;
  }
  .webpab-ext-link {
    color: inherit;
    display: block;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      color: #20a4b8;
      text-decoration: underline;
    }
  }
</style>
